import angular from 'angular';
import angularBootstrap from 'angular-ui-bootstrap';
import i18n from '../i18n';
import datepickDayDecorator from './daypicker-decorator';
import datepickMonthDecorator from './monthpicker-decorator';
import detepickerDirective from './date-picker-directive';
import datepickerPopupTemplate from './templates/popup.tpl.html';
import uibDatePickerTemplate from './templates/uib-datepicker.tpl.html';
import daypickerTemplate from './templates/date-picker-day-popup.tpl.html';
import monthpickerTemplate from './templates/date-picker-month-popup.tpl.html';

function run($templateCache) {
  /*
  Overide angular-ui bootstrap's datepicker popup template
  0.13.3 changed popup template to include ng-if which as a result broke binding in date-range
  Using popup template from 0.13.0 since it uses ng-show instead of ng-if
  */
  $templateCache.put('template/datepicker/popup.html', datepickerPopupTemplate);
  $templateCache.put('templates/uib-datepicker.tpl.html', uibDatePickerTemplate);
  $templateCache.put('templates/date-picker-day-popup.tpl.html', daypickerTemplate);
  $templateCache.put('templates/date-picker-month-popup.tpl.html', monthpickerTemplate);
}
run.$inject = ['$templateCache'];

/**
 * @ngdoc module
 * @deprecated akamai.components.date
 * @name akamai.components.date-picker
 *
 * @description
 * Date-picker is an interactive calendar component that allows users to select a date
 * from a month view. Users have the ability to clear a selected date. This implementation
 * is intended to be used as a form control.
 *
 * @guideline https://design.akamai.com/components/date-picker/
 *
 * @example day-picker.html
 * <akam-date-picker
 *   mode="day"
 *   ng-model="..."
 *   min="..."
 *   max="..."
 *   ng-change="..."
 *   format="..."
 *   is-disabled="...">
 * </akam-date-picker>
 *
 * @example month-picker.html
 * <akam-date-picker
 *  mode="month"
 *  ng-model="..."
 *  min="..."
 *  max="..."
 *  ng-change="..."
 *  format="..."
 *  not-clearable>
 * </akam-date-picker>
 */
export default angular.module('akamai.components.date-picker', [
  angularBootstrap,
  i18n.name
])

  .run(run)

  // decorators for the day pickers to add on scope variables for disabling nav
  .config(datepickDayDecorator)

  // decorators for the month pickers to add on scope variables for disabling nav
  .config(datepickMonthDecorator)

/**
 * @ngdoc directive
 *
 * @name akamDatePicker
 *
 * @description Creates a date picker control.
 *
 * @restrict E
 *
 * @param {Date} ng-model The date value. Must be a valid JavaScript `Date` object.
 *
 * @param {string|TranslateKey} [placeholder] The placeholder text.
 *
 * @param {string} [mode="day"] Determines the display mode. Can be either `day` or `month`.
 *
 * @param {Date} min The earliest date users can select. Dates before this point are disabled.
 *
 * @param {Date} max The latest date users can select. Dates after this point are disabled.
 *
 * @param {string} [format="EEE, MMM dd, yyyy" | format="MMM yyyy"] An angular-compatible date
 * format. By default, `"EEE, MMM dd, yyyy"` will be used when in `day` mode. `"MMM yyyy"` will be
 * used when in `month` mode.
 *
 * @param {boolean} [is-disabled=false] If disabled, no user interaction will be possible.
 *
 * @param {boolean} [is-readonly=false] If readonly, no user interaction will be possible but the
 * text will be easier to read.
 *
 * @param {*} [not-clearable] If present, the date will not be clearable.
 *
 */
  .directive('akamDatePicker', detepickerDirective);
